import { render } from "./User-edit.vue?vue&type=template&id=409ae00c"
import script from "./User-edit.vue?vue&type=script&lang=js"
export * from "./User-edit.vue?vue&type=script&lang=js"

import "./User-edit.vue?vue&type=style&index=0&id=409ae00c&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__